module.exports = __webpack_public_path__ + "static/media/importFlybook3.601a971b.png";